import { get } from '@navent-jobs/config'

class CurrencyService {
  public getCurrency = (idPais: number) => {
    return get(`/api-company/monedasPais?paisId=${idPais}`)
  }
}

const currencyService = new CurrencyService()
export default currencyService
